module.exports = __webpack_public_path__ + "static/img/90.900b99a.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/image/90.jpg
// module id = JkGN
// module chunks = 1